// /ops/status — «Состояние» (002); с 0.22.2 — раздел «Сервис» «Настроек», адрес прежний. Полная
// панель — ops.status.read (сопровождение), краткая — ops.health.read (администратор клиента):
// какая — решает страница по правам.
import { createFileRoute } from '@tanstack/react-router';
import { StatusPage } from '../../../features/ops/StatusPage.tsx';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/ops/status')({
  beforeLoad: requireSection('status'),
  staticData: { crumb: 'Состояние' },
  component: StatusPage,
});
